<template>
  <div>
    <div class="map-tab">
      <div class="Map-tab-box">
        <span v-for="item in tabData"
              :key="item.types"
              :class="{'active':checkedVal==item.name,'MapTab':true}"
              @click="checkedTab(item)">{{item.name}}</span>
      </div>
    </div>
    <div id="container"
         class="container">
      <div class="mask">
        <div class="mask-header">
          <div class="Map-tab-box">
            <span v-for="item in tabData"
                  :key="item.types"
                  :class="{'activeB':checkedVal==item.name,'MapTab':true}"
                  @click="checkedTab(item)">{{item.name}}</span>
          </div>
        </div>
        <div class="mask-content">
          <div v-for="(item,i) in rimInfo"
               :key="i"
               :class="{address:true}"
               @click="checkedaddress(item.poiName,item.poiLng,item.poiLat)">
            <div class="address-box">
              <div class="address-info"><span :class="{activeC:checkedPosition==item.poiName}">{{item.poiName}}</span><span class="distance">{{(item.distance/1000).toFixed(1)}}km</span> </div>
              <div class="address-detail"
                   :class="{activeC:checkedPosition==item.poiName}">{{item.address}}</div>
            </div>
          </div>
          <div v-show="isShow"
               class="not-result">
            <img class="not-result-img"
                 src="../../assets/img/pic-shujuk.png" />
            <span class="not-result-text">抱歉，附近暂无{{checkedVal}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
/* eslint-disable */
import { aroundPoi } from '@/api/seekWarehouse/seekWarehouse'
import { mapMutations } from 'vuex'
// import MapTab from './component/MapTab.vue'
import sha1 from 'sha1'
import iconGaosu from '@/assets/img/icon-gaosu.png'
import iconGaosuCurrent from '@/assets/img/icon_gaosu_current.png'
import iconAirplane from '@/assets/img/icon-airplane.png'
import iconAirplaneCurrent from '@/assets/img/icon_airplane_current.png'
import iconTrain from '@/assets/img/icon-train.png'
import iconTrainCurrent from '@/assets/img/icon_train_current.png'
import iconSubway from '@/assets/img/icon-subway.png'
import iconSubwayCurrent from '@/assets/img/icon_subway_current.png'
import iconbBus from '@/assets/img/icon-bus.png'
import iconbBusCurrent from '@/assets/img/icon_bus_current.png'
import iconHouseMap from '@/assets/img/icon-house-map.png'

export default {
  components: {
    // MapTab,
  },
  props: {
    detail: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      map: null,
      tabData: [
        {
          name: '高速岔口',
          types: '190304|190305',
          icon: iconGaosu,
          current: iconGaosuCurrent,
        },
        {
          name: '机场',
          types: '150102|150104',
          icon: iconAirplane,
          current: iconAirplaneCurrent,
        },
        {
          name: '火车站',
          types: '150200',
          icon: iconTrain,
          current: iconTrainCurrent,
        },
        {
          name: '地铁站',
          types: '150500|150501',
          icon: iconSubway,
          current: iconSubwayCurrent,
        },
        {
          name: '公交站',
          types: '150702',
          icon: iconbBus,
          current: iconbBusCurrent,
        },
      ],
      positionXY: {},
      rimInfo: [],
      checkedPosition: null,
      flag: '1',
      markers: [],
      checkedVal: '高速岔口',
      warehouseName: null,
      image: iconGaosu,
      currentImage: iconGaosuCurrent,
      markersList: [],
      poiName: '',
    }
  },
  computed: {
    isShow() {
      return !(this.rimInfo?.length > 0)
    },
  },
  async created() {
    const { detail } = this;
    this.warehouseName = detail.warehouseSourceName
    this.positionXY = {
      lng: detail.longitude,
      lat: detail.latitude,
    }
    const parame = {
      centerLng: detail.longitude,
      centerLat: detail.latitude,
      types: '190304|190305',
      radius: 30000,
    }
    const paraString = this.tranString(parame)
    localStorage.timestamp = this.timestamp()
    const appId = 'oms'
    const secret = '961b15dccc58c14dc455b30dd2391cce'
    const resss = sha1(appId + secret + this.timestamp() + paraString)
    localStorage.signCode = resss
    const res = await aroundPoi(parame)
    this.rimInfo = res.data || []
    const markers = this.rimInfo.map((v) => {
      return { lng: v.poiLng, lat: v.poiLat, poiName: v.poiName }
    })
    this.markersList = markers
    this.rederMarker(markers)
  },
  mounted() {
    const that = this
    this.map = new AMap.Map(document.getElementById('container'), {
      resizeEnable: true,
      center: [this.positionXY.lng, this.positionXY.lat], // 中心点坐标
      zoom: 14,
      mapStyle: 'amap://styles/5415d2af821d8107c2bafa18f73bcf5b',
    })
    that.positionXY = this.map.getCenter()
    AMap.plugin(
      [
        'AMap.ToolBar',
        'AMap.Marker',
        'AMap.Scale',
        'AMap.Icon',
        'AMap.Size',
        'AMap.Pixel',
        'AMap.InfoWindow',
      ],

      function () {
        // 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
        // that.map.addControl(new AMap.ToolBar())
        // 在图面添加比例尺控件，展示地图在当前层级和纬度下的比例尺
        that.map.addControl(new AMap.Scale())
        const Icon = new AMap.Icon({
          size: new AMap.Size(25, 34),
          image: iconHouseMap,
          imageSize: new AMap.Size(80, 56),
          imageOffset: new AMap.Pixel(0, 0),
        })
        const marker = new AMap.Marker({
          icon: Icon,
          offset: new AMap.Pixel(-13, -30),
          position: new AMap.LngLat(that.positionXY.lng, that.positionXY.lat),
        })
        const markerContent = document.createElement('div')
        markerContent.className = 'marker-content'
        // 点标记中的图标
        const markerImg = document.createElement('img')
        markerImg.className = 'markerlnglat'
        markerImg.src = iconHouseMap
        markerContent.appendChild(markerImg)
        const markerSpan = document.createElement('div')
        markerSpan.className = 'marker'
        markerSpan.innerHTML = that.warehouseName
        const markerDiv = document.createElement('div')
        markerDiv.className = 'marker-div'
        markerDiv.innerHTML = ''
        markerSpan.appendChild(markerDiv)
        markerContent.appendChild(markerSpan)
        marker.setContent(markerContent) // 更新点标记内容
        marker.setMap(that.map)
      }
    )
  },

  methods: {
    // 地图类型切换
    // checkedTab(val) {
    //   // this.isChecked = val
    // },
    ...mapMutations('warehouse', ['setchecked']),
    async checkedTab(v) {
      // 切换tab时关闭弹窗
      this.infobox && this.infobox.close(this.map)
      this.image = v.icon
      this.poiName = ''
      this.currentImage = v.current
      this.setchecked(v.name)
      this.checkedVal = v.name
      this.checkedPosition = null
      const that = this
      const parame = {
        centerLng: that.positionXY.lng,
        centerLat: that.positionXY.lat,
        types: v.types,
        radius: 30000,
      }
      const paraString = this.tranString(parame)
      localStorage.timestamp = this.timestamp()
      const appId = 'oms'
      const secret = '961b15dccc58c14dc455b30dd2391cce'
      const resss = sha1(appId + secret + this.timestamp() + paraString)
      localStorage.signCode = resss
      const res = await aroundPoi(parame)
      that.rimInfo = res.data
      const markers = (that.rimInfo || []).map((v) => {
        return { lng: v.poiLng, lat: v.poiLat, poiName: v.poiName }
      })
      this.markersList = markers
      this.rederMarker(markers)
      this.map.setFitView(that.markers)
    },
    checkedaddress(name, lng, lat) {
      this.checkedPosition = name
      this.poiName = name
      this.rederMarker(this.markersList)
      // let markerCar = new AMap.Marker({
      //   position: [lng, lat],
      //   imageSize: new AMap.Size(40, 50),
      //   offset: new AMap.Pixel(-18, -22),
      // });
      // this.map.setFitView(markerCar)
      this.infobox.setContent(name)
      this.infobox.open(this.map, [lng, lat])
    },

    rederMarker(markers) {
      this.map.remove(this.markers)
      const that = this
      const icon = {
        size: new AMap.Size(40, 50),
        // image: this.image,
        // imageSize: new AMap.Size(32, 40),
        imageOffset: new AMap.Pixel(0, 0),
      }
      for (let i = 0; i < markers.length; i += 1) {
        AMap.plugin(
          ['AMap.Marker', 'AMap.InfoWindow', 'AMap.Pixel', 'AMap.LngLat'],
          function () {
            if (markers[i].poiName === that.poiName) {
              icon.image = that.currentImage
              icon.imageSize = new AMap.Size(40, 50)
            } else {
              icon.image = that.image
              icon.imageSize = new AMap.Size(32, 40)
            }
            that.marker1 = new AMap.Marker({
              icon: new AMap.Icon(icon),
              offset: new AMap.Pixel(-13, -30),
              position: new AMap.LngLat(markers[i].lng, markers[i].lat),
            })
            that.markers.push(that.marker1)
            that.marker1.setMap(that.map)
            that.addInfo(that.marker1, markers[i].poiName)
          }
        )
      }
    },
    tranString(parame) {
      const newpara = {}
      const para = Object.keys(parame).sort()
      para.forEach((v) => {
        newpara[v] = parame[v]
      })
      return JSON.stringify(newpara)
    },
    timestamp() {
      return new Date().getTime()
    },
    addInfo(dom, name) {
      this.infobox = new AMap.InfoWindow({
        offset: new AMap.Pixel(10, -30),
      })
      dom.content = name
      dom.on('click', this.markerClick1)
    },
    markerClick1(e) {
      this.poiName = e.target.content
      this.rederMarker(this.markersList)
      this.infobox.setContent(e.target.content)
      this.infobox.open(this.map, e.target.getPosition())
    },
  },
}
</script>

<style lang="less" scoped>
.map-tab {
  border-bottom: 1px solid #f5f6f7;
  margin-bottom: 20px;
  cursor: pointer;
}
.container {
  width: 100%;
  height: 600px;
  position: relative;
  z-index: 99;
}
.mask {
  width: 392px;
  position: absolute;
  top: 32px;
  right: 32px;
  z-index: 1111111;
}
.mask-header {
  background-color: #fff;
  margin-bottom: 8px;
  padding: 6px;
  box-shadow: 0px 7px 12px 1px rgba(126, 126, 126, 0.15);
  border-radius: 4px;
}
.mask-content {
  background-color: #fff;
  height: 303px;
  overflow: auto;
  box-shadow: 0px 7px 12px 1px rgba(126, 126, 126, 0.15);
  border-radius: 4px;
  z-index: 11111;
  padding-top: 17px;
  .address {
    padding: 0px 24px;
    .address-box {
      border-bottom: 1px solid #f5f6f7;
      padding: 15px 0px;
      .address-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        color: #171717;
        span:nth-of-type(1) {
          font-weight: bold;
          display: inline-block;
          width: 225px;
          margin-right: 20px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .distance {
        color: #a9abae;
        font-size: 12px;
        background-image: url('../../assets/img/icon-juli.png');
        background-repeat: no-repeat;
        background-position: 1px 1px;
        background-size: 16px 16px;
        padding-left: 20px;
      }
      .address-detail {
        font-size: 14px;
        color: #ccc;
      }
      .address-box:nth-last-child(1) {
        border-bottom: 0px;
      }
    }
  }
  .address:hover {
    background: #f2fbf8;
  }
}
.activeC {
  color: #06b880 !important;
}
.not-result {
  margin: 22px 100px 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .not-result-img {
    width: 120px;
    height: 120px;
    margin-bottom: 24px;
  }
  .not-result-text {
    font-size: 14px;
    color: #a9abae;
  }
}
/deep/.amap-icon {
  // width: 36px !important;
  // height: 45px !important;
}
/deep/.amap-logo {
  display: none !important;
}
/deep/.amap-copyright {
  display: none !important;
}
.Map-tab-box {
  width: 100%;
  height: 100%;
  position: relative;
  top: 2px;
}
.MapTab {
  display: inline-block;
  padding: 10px;
  width: 76px;
  color: #a9abae;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  &:active {
    color: #029869;
  }
  &:hover {
    color: #06b880;
  }
  &.active {
    border-bottom: 2px solid #06b880;
    color: #06b880;
  }
  &.activeB {
    background: #06b880;
    color: #fff;
    border-radius: 4px;
  }
}
/deep/.amap-info {
  /deep/& > div:nth-last-child(1) {
    top: -46px !important;
    left: -10px !important;
  }
}
/deep/.amap-info-close {
  display: none;
}
/deep/ .amap-info-content {
  padding: 8px 6px;
  font-weight: 500;
  color: #171717;
  box-shadow: 0px 0px 6px 0px #999E9E;
}
/deep/ .amap-info-sharp {
  bottom: 4px;
}
/deep/.markerlnglat {
  width: 80px !important;
  height: 56px !important;
}
/deep/.amap-marker-content /deep/.marker {
  position: relative !important;
  background: #fff !important;
  border-radius: 6px !important;
  top: -10px !important;
  left: -10px !important;
}
/deep/.amap-marker {
  width: 150px !important;
  .marker {
    display: inline-block !important;
    padding: 8px 6px;
    position: absolute !important;
    background: #fff !important;
    border-radius: 6px !important;
    box-shadow: 0px 0px 6px 0px #999E9E;
    top: -50px !important;
    left: 10px !important;
    position: relative;
    color: #171717;
    font-weight: 500;
  }
  .marker-div {
    width: 0px;
    height: 0px;
    border-top: 10px solid #fff;
    border-left: 10px solid #fff;
    position: absolute;
    left: 32px;
    bottom: -5px;
    transform: rotate(45deg);
  }
}
.marker {
  position: absolute;
  top: -20px;
  right: -118px;
  color: #fff;
  padding: 4px 10px;
  box-shadow: 1px 1px 1px rgba(10, 10, 10, 0.2);
  white-space: nowrap;
  font-size: 12px;
  font-family: '';
  background-color: #25a5f7;
  border-radius: 3px;
}
</style>